// PrioritySelector.js - Composant pour sélectionner/modifier la priorité
import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { getPriorityStyles } from './TimelineHelpers';

const PrioritySelector = ({ priority, onChange, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const priorities = [
        { value: 'high', label: 'Haute' },
        { value: 'medium', label: 'Moyenne' },
        { value: 'low', label: 'Basse' }
    ];

    const currentPriorityStyles = getPriorityStyles(priority);

    // Fermer le dropdown quand on clique à l'extérieur
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handlePriorityChange = (newPriority) => {
        setIsOpen(false);
        if (onChange && newPriority !== priority) {
            onChange(newPriority);
        }
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    if (!disabled) {
                        setIsOpen(!isOpen);
                    }
                }}
                disabled={disabled}
                className={`interactive-element flex items-center gap-1 text-xs px-1 py-0.5 rounded flex-shrink-0 font-light border bg-gray-50 border-gray-200 hover:bg-gray-100 transition-colors ${
                    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                }`}
                style={{ fontSize: '10px' }}
            >
                <span className={currentPriorityStyles.text}>
                    {currentPriorityStyles.label}
                </span>
                {!disabled && <ChevronDown className="w-2 h-2 text-gray-400" />}
            </button>

            {isOpen && !disabled && (
                <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 min-w-[80px]">
                    {priorities.map((priorityOption) => {
                        const priorityStyles = getPriorityStyles(priorityOption.value);
                        return (
                            <button
                                key={priorityOption.value}
                                onClick={() => handlePriorityChange(priorityOption.value)}
                                className={`w-full text-left px-2 py-1 text-xs hover:bg-gray-50 transition-colors ${
                                    priority === priorityOption.value ? 'bg-gray-100' : ''
                                }`}
                                style={{ fontSize: '10px' }}
                            >
                                <span className={priorityStyles.text}>
                                    {priorityStyles.label}
                                </span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default PrioritySelector;